<template>
  <el-card>
    <section>
      <el-card>
        <el-form size="small" :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="旧密码" prop="passwordOld">
            <el-input type="password" v-model="editForm.passwordOld" placeholder="请输入旧密码" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="editForm.password" placeholder="请输入新密码" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="passwordAgain">
            <el-input type="password" v-model="editForm.passwordAgain" placeholder="请再次输入新密码" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="" prop="passwordAgain">
            <p style="color: #e64242">
              密码长度不能少于6位
            </p>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click.native="editFormVisible = false">取消</el-button>
            <el-button size="small" type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </section>
  </el-card>
</template>

<script>

import { doPost } from '../../api/api'

export default {
  data () {
    return {
      user: {},
      editLoading: false,
      editFormRules: {
        passwordOld: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        passwordAgain: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ]
      },
      // 编辑界面数据
      editForm: {
        passwordOld: '',
        password: '',
        passwordAgain: ''
      }
    }
  },
  methods: {
    editSubmit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.editForm.password === this.editForm.passwordOld) {
            this.$message({
              message: '新密码不能和旧密码一致',
              type: 'error'
            })
            return
          }

          if (this.editForm.password !== this.editForm.passwordAgain) {
            this.$message({
              message: '确认新密码不一致',
              type: 'error'
            })
            return
          }
          if (this.editForm.password.length < 6) {
            this.$message({
              message: '密码长度不能少于6位',
              type: 'error'
            })
            return
          }
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true
            var para = {
              oldPassword: this.editForm.passwordOld,
              id: this.user.id,
              password: this.editForm.password
            }
            doPost('/user/changePassword', para).then(res => {
              if (res.code === 101) {
                this.$message({
                  message: res.result,
                  type: 'error'
                })
                this.editLoading = false
              } else {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.editLoading = false
                sessionStorage.removeItem('user')
                sessionStorage.removeItem('menuList')
                this.$router.push('/login')
              }
            })
          })
        }
      })
    }
  },
  mounted () {
    let user = JSON.parse(sessionStorage.getItem('user'))
    this.user = user
  }
}

</script>

<style scoped>

</style>
